import {
    FETCH_LOCATION_PRICES,
    FETCH_LOCATION_PRICES_SUCCESS,
    FETCH_LOCATION_PRICES_FAILED,
    EDIT_LOCATION_PRICE
  } from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, set } from "firebase/database";
  
export const fetchLocationPrices = () => (dispatch) => {
  
    const {
      locationPricesRef
    } = firebase;
  
    dispatch({
      type: FETCH_LOCATION_PRICES,
      payload: null,
    });
    onValue(locationPricesRef, (snapshot) => {
      if (snapshot.val()) {
        dispatch({
          type: FETCH_LOCATION_PRICES_SUCCESS,
          payload: snapshot.val()
        });
      } else {
        dispatch({
          type: FETCH_LOCATION_PRICES_FAILED,
          payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
        });
      }
    });
  };
  
export const editLocationPrice = (data, method) => (dispatch) => {
    const {
        locationPricesRef
    } = firebase;
  
    dispatch({
      type: EDIT_LOCATION_PRICE,
      payload: method
    });
    set(locationPricesRef, data);
  }